import clsx from "clsx";

import type { DisplayState } from "./state";

interface CounterProps {
  label: string;
  value: number;
  /** The state this number counts, when it counts one. Only a state gives the number its colour. */
  tone?: DisplayState;
  className?: string;
}

/** A number with its word: "12 waiting for the SME". */
export function Counter({ label, value, tone, className }: CounterProps) {
  return (
    <div className={clsx("counter", className)} data-state={tone}>
      <span className="counter__value">{value}</span> <span className="counter__label">{label}</span>
    </div>
  );
}
